import { StatusType } from 'components'

import { ConnectionStatus } from '../types'

export const translateStatus = (status: ConnectionStatus, error?: string): StatusType => {
  if (status === 'disabled') {
    if (!!error && error.length > 0) {
      return 'error'
    }
    return 'inactive'
  }

  return status
}
